import { jsx as _jsx } from "react/jsx-runtime";
import { SpecraText } from '@mono/ui-components';
export function RegistryListNote({ children }) {
    return /*#__PURE__*/ _jsx(SpecraText, {
        as: "p",
        size: "body-ui",
        tone: "muted",
        children: children
    });
}
